var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuteVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.234,
    height: 34.914,
    viewBox: "0 0 32.234 34.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-volume-off",
    "data-name": "Icon ionic-ios-volume-off",
    transform: "translate(-4.5 -3.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M30.733,38.295a1.189,1.189,0,0,1-1.033-.588L10.553,5.162a1.175,1.175,0,0,1,.428-1.62,1.2,1.2,0,0,1,1.637.428L31.765,36.515a1.183,1.183,0,0,1-1.033,1.78Z",
    transform: "translate(1.141 0)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4236",
    "data-name": "Group 4236",
    transform: "translate(4.5 7.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M10.292,14.62H5.843A1.342,1.342,0,0,0,4.5,15.963v6.715a1.347,1.347,0,0,0,1.343,1.343h4.449l5.49,4.407a1.369,1.369,0,0,0,.848.294,1.275,1.275,0,0,0,.579-.134,1.343,1.343,0,0,0,.764-1.209V16.962l-3.4-5.775Z",
    transform: "translate(-4.5 -5.892)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M32.672,20.181h0a18.319,18.319,0,0,0-5.5-13.137,1.009,1.009,0,1,0-1.419,1.435,16.294,16.294,0,0,1,4.9,11.7h0a16.328,16.328,0,0,1-3.5,10.14l1.091,1.847a18.291,18.291,0,0,0,4.424-11.987Z",
    transform: "translate(-0.438 -6.752)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M28,19.615h0A13.641,13.641,0,0,0,24.067,9.97a1.009,1.009,0,0,0-1.435,1.419,11.625,11.625,0,0,1,3.358,8.235h0a11.73,11.73,0,0,1-1.167,5.137l1.192,2.023A13.775,13.775,0,0,0,28,19.615Z",
    transform: "translate(-1.041 -6.186)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M22.994,19.049h0a8.706,8.706,0,0,0-2.518-6.161,1.008,1.008,0,0,0-1.427-.008,1.227,1.227,0,0,0-.134.159l4.038,6.867C22.977,19.62,22.994,19.335,22.994,19.049Z",
    transform: "translate(-1.706 -5.62)",
    fill: "#fed700"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteVolume);
export default __webpack_public_path__ + "static/media/muteVolume.0567eb27209236d227e54be44cf5b5c1.svg";
export { ForwardRef as ReactComponent };